module.exports = __webpack_public_path__ + "static/media/img7.682083ad.webp";